import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'host-input-with-error',
  templateUrl: './input-with-error.component.html',
  styleUrls: ['./input-with-error.component.scss']
})
export class InputWithErrorComponent implements OnInit {
  @Input() errorText = ''; // @deprecated
  @Input() i18nErrorKey = '';
  @Input() showError = false;

  constructor() { }

  ngOnInit() { }
}
